import styled from "styled-components";

export const Container = styled.div`
  display: ${({ $display = 'inherit' }) => $display};
  justify-content: ${({ $justifycontent = 'unset' }) => $justifycontent};
  align-items: ${({ $alignitems = 'unset' }) => $alignitems};
  flex-direction: ${({ $flexdirection = 'unset' }) => $flexdirection};
  width: ${({ $width = '90%' }) => $width};
  max-width: 100%;
  box-sizing: border-box;
  height: ${({ $height = 'max-content' }) => $height};
  margin: ${({ $margin = '1rem auto 0 auto' }) => $margin};
  padding: ${({ $padding = '0' }) => $padding};
  background-color: ${({ $backgroundcolor = '#f8f8f8' }) => $backgroundcolor};
  border-radius: ${({ $borderRadius = '0' }) => $borderRadius};
  border: ${({ $border = 'none' }) => $border};
  box-shadow: ${({ $boxshadow = '0px 4px 6px 0px rgba(0, 0, 0, 0.1)' }) => $boxshadow};

  .loader {
    width: 48px;
    height: 48px;
    border: 5px solid var(--ui-primary);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
`;